import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface PlanPriceWarningProps {
  isEditing: boolean;
  originalPrice?: number;
  newPrice?: number;
}

export function PlanPriceWarning({ isEditing, originalPrice, newPrice }: PlanPriceWarningProps) {
  if (!isEditing || originalPrice === newPrice) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>
        <Box display="flex" alignItems="center" gap={1}>
          Atenção: Alteração de Preço
        </Box>
      </AlertTitle>
      <Typography variant="body2">
        <strong>Importante:</strong> A alteração do preço deste plano afetará apenas novos pagamentos.
        Assinaturas já ativas continuarão com o preço original até o próximo pagamento.
      </Typography>
      <Box mt={1}>
        <Typography variant="body2" color="text.secondary">
          • Preço atual: R$ {originalPrice?.toFixed(2)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Novo preço: R$ {newPrice?.toFixed(2)}
        </Typography>
      </Box>
    </Alert>
  );
}
